(function() {
    function getSectionsToRender() {
        return [
          {
            selector: 'js-main-product',
            sectionId: document.querySelector('[js-main-product]')?.dataset.section
          },
          {
            selector: 'js-product-details',
            sectionId: document.querySelector('[js-product-details]')?.dataset.sectionId
          },
          {
            selector: 'js-product-image-with-text',
            sectionId: document.querySelector('[js-product-image-with-text]')?.dataset.sectionId
          },
          {
            selector: 'js-product-whats-inside',
            sectionId: document.querySelector('[js-product-whats-inside]')?.dataset.sectionId
          },
          {
            selector: 'js-product-better_than_the_rest_image',
            sectionId: document.querySelector('[js-product-better_than_the_rest_image]')?.dataset.sectionId
          },
          {
            selector: 'js-product-recipes',
            sectionId: document.querySelector('[js-product-recipes]')?.dataset.sectionId
          },
          {
            selector: 'js-product-table-list',
            sectionId: document.querySelector('[js-product-table-list]')?.dataset.sectionId
          },
          {
            selector: 'js-product-reviews',
            sectionId: document.querySelector('[js-product-reviews]')?.dataset.sectionId
          },
          {
            selector: 'js-product-recommendations',
            sectionId: document.querySelector('[js-product-recommendations]')?.dataset.sectionId
          }
        ];
    };    

    function renderSections(handle) {
        getSectionsToRender().forEach(section => {
            let url = `/products/${handle}?section_id=${section.sectionId}`;
            if(location.pathname.includes('/en-')) {
              url = `${location.origin}/${location.pathname.split('/')[1]}/products/${handle}?section_id=${section.sectionId}`;
            }
        
            fetch(url)
            .then( response => response.text())
            .then(html => {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                
                const elementToReplace = document.querySelector(`[${section.selector}]`);

                if(elementToReplace) {
                    elementToReplace.innerHTML = doc.querySelector(`[${section.selector}]`) ? doc.querySelector(`[${section.selector}]`).innerHTML : '';
                };

                if(section.selector === 'js-main-product') {
                    document.dispatchEvent(new CustomEvent("accordion:init"));
                    document.dispatchEvent(new CustomEvent("product-meta-video-slider:init"));
                    document.dispatchEvent(new CustomEvent("main-product-video-popup:init"))
                    document.dispatchEvent(new CustomEvent("product-meta-upsell-slider:init"));
                }else if(section.selector === 'js-product-details') {
                    document.dispatchEvent(new CustomEvent("product-object-column-slider:init"));
                    document.dispatchEvent(new CustomEvent("product_object_marquee:init"));
                }else if(section.selector === 'js-product-image-with-text') {
                    document.dispatchEvent(new CustomEvent("product-tabs:init"));
                }else if(section.selector === 'js-product-whats-inside') {
                    document.dispatchEvent(new CustomEvent("tabs-collection-new:init"));
                    document.dispatchEvent(new CustomEvent("tabs-slider-new:init"));
                }else if(section.selector === 'js-product-better_than_the_rest_image') {
                    document.dispatchEvent(new CustomEvent("Product_object_table_desktop_slider:init"));
                    document.dispatchEvent(new CustomEvent("Product_object_table_mobile_slider:init"));
                }else if(section.selector === 'js-product-recipes') {
                    document.dispatchEvent(new CustomEvent("recipes-slider:init"));
                }else if(section.selector === 'js-product-reviews') {
                    const api = new Yotpo.API(yotpo);
                    api?.refreshWidgets();
                }else if(section.selector === 'js-product-recommendations') {
                    document.dispatchEvent(new CustomEvent("product-recommendation:init"));
                }

                document.dispatchEvent(new CustomEvent("update-currency:init"))
            })
            .catch(function(error) {
                //console.log(error);
            });
        });
    };

    class relatedProducts extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                swatchItem: "[js-swatch-item]",
                swatchHandle: "[js-swatch-handle]"
            };
    
            this.classes = {
                activeClass: 'active'
            }
    
            this.swatchItems = this.querySelectorAll(this.selectors.swatchItem);
            this.swatchHandle = this.querySelector(this.selectors.swatchHandle);
            
            this.init();
        };
    
        init() {
            this.swatchItems.forEach( swatchItem => {
                swatchItem.addEventListener('click', ({currentTarget}) => {
                    this.toggleProduct(currentTarget);
                })
            });
        };
    
        toggleProduct(targetProduct) {
            const productHandle = targetProduct.dataset.productHandle;
            const swatchHandle = targetProduct.dataset.swatchHandle;
            
            this.updateState(targetProduct);
            this.updateHistoryState(productHandle);
            renderSections(productHandle);
        };
    
        updateState(targetEl) {
            document.body.classList.add("disabled");
            this.swatchItems.forEach( item => item.classList.remove(this.classes.activeClass));
            targetEl.classList.add(this.classes.activeClass);
        };
    
        updateHistoryState(handle) {
            var newurl = `${window.location.protocol}//${window.location.host}/products/${handle}`;
            if(location.pathname.includes('/en-')) {
              newurl = `${location.origin}/${location.pathname.split('/')[1]}/products/${handle}`;
            }
            window.history.pushState({path: newurl}, '', newurl);
        };
    }
      
    customElements.define('related-products', relatedProducts);
})()